import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { useTutorialSafe } from '@/app/contexts/TutorialContext';
import { TutorialWelcome } from './TutorialWelcome';
import type { TutorialModule } from '@/app/types/tutorial';

interface TutorialHelpButtonProps {
  currentModule: TutorialModule;
  variant?: 'icon' | 'button';
}

export function TutorialHelpButton({ currentModule, variant = 'icon' }: TutorialHelpButtonProps) {
  const [showWelcome, setShowWelcome] = useState(false);
  
  // Use safe version that doesn't throw
  const tutorial = useTutorialSafe();

  const handleClick = () => {
    if (tutorial?.startTutorial) {
      // Start tutorial directly for current module
      tutorial.startTutorial(currentModule);
    } else {
      // Fallback: show welcome dialog
      setShowWelcome(true);
    }
  };

  if (variant === 'icon') {
    return (
      <>
        <button
          onClick={handleClick}
          className="p-2 rounded-full hover:bg-black/10 dark:hover:bg-white/10 transition-colors"
          title="Tutorial starten"
          data-tutorial="help-button"
        >
          <HelpCircle className="w-5 h-5" style={{ color: 'var(--md-primary)' }} />
        </button>

        {showWelcome && <TutorialWelcome onClose={() => setShowWelcome(false)} />}
      </>
    );
  }

  return (
    <>
      <Button
        onClick={handleClick}
        variant="outline"
        size="sm"
        className="gap-2"
        data-tutorial="help-button"
      >
        <HelpCircle className="w-4 h-4" />
        Tutorial starten
      </Button>

      {showWelcome && <TutorialWelcome onClose={() => setShowWelcome(false)} />}
    </>
  );
}